import { createContext, useContext, useEffect, useMemo, useState } from "react";

import en from "./locales/en";
import hi from "./locales/hi";
import hinglish from "./locales/hinglish";
import gu from "./locales/gu";
import mr from "./locales/mr";
import pa from "./locales/pa";
import ta from "./locales/ta";
import te from "./locales/te";

const translations = {
  en,
  hi,
  en_in: hinglish,
  gu,
  mr,
  pa,
  ta,
  te,
};

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (key) => key,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    const saved = localStorage.getItem("moxpal_lang");
    if (saved && translations[saved]) {
      setLangState(saved);
    }
  }, []);

  const setLang = (code) => {
    if (!translations[code]) return;
    localStorage.setItem("moxpal_lang", code);
    setLangState(code);
  };

  const t = (key) => {
    if (!key || typeof key !== 'string') return '';
    return translations[lang]?.[key] || translations.en?.[key] || key;
  };

  const value = useMemo(() => ({ lang, setLang, t }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}